const BOOKING_ACCESS_KEY_PREFIX = 'customer-booking-access';

type BookingAccessEntry = {
  token: string;
  expiresAtUtc: string;
};

const buildStorageKey = (phone: string, registrationNumber: string): string =>
  `${BOOKING_ACCESS_KEY_PREFIX}:${phone.trim()}:${registrationNumber.trim().toUpperCase()}`;

export const saveBookingAccessToken = (
  phone: string,
  registrationNumber: string,
  token: string,
  expiresAtUtc: string,
) => {
  const key = buildStorageKey(phone, registrationNumber);
  const payload: BookingAccessEntry = {
    token,
    expiresAtUtc,
  };

  sessionStorage.setItem(key, JSON.stringify(payload));
};

export const clearBookingAccessToken = (phone: string, registrationNumber: string) => {
  const key = buildStorageKey(phone, registrationNumber);
  sessionStorage.removeItem(key);
};

export const getBookingAccessToken = (phone: string, registrationNumber: string): string | null => {
  const key = buildStorageKey(phone, registrationNumber);
  const rawValue = sessionStorage.getItem(key);
  if (!rawValue) {
    return null;
  }

  try {
    const parsed = JSON.parse(rawValue) as BookingAccessEntry;
    if (!parsed?.token || !parsed?.expiresAtUtc) {
      sessionStorage.removeItem(key);
      return null;
    }

    const expiresAt = new Date(parsed.expiresAtUtc);
    if (Number.isNaN(expiresAt.getTime()) || expiresAt <= new Date()) {
      sessionStorage.removeItem(key);
      return null;
    }

    return parsed.token;
  } catch {
    sessionStorage.removeItem(key);
    return null;
  }
};
